import { render, staticRenderFns } from "./MobileList.vue?vue&type=template&id=dec32c78&scoped=true&"
import script from "./MobileList.vue?vue&type=script&lang=ts&"
export * from "./MobileList.vue?vue&type=script&lang=ts&"
import style0 from "./MobileList.vue?vue&type=style&index=0&id=dec32c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec32c78",
  null
  
)

export default component.exports